import React from "react";
import {
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaInstagram,
  FaTiktok,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  return (
    <section id="contact" className="section contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">
          Have questions or want to join our community? We'd love to hear from
          you!
        </p>

        <div className="contact-content">
          <div className="contact-info-column animate-fade-in-left">
            <div className="contact-card">
              <h3>Contact Information</h3>
              <div className="contact-items">
                <div className="contact-item">
                  <FaEnvelope className="contact-icon" />
                  <div>
                    <h4>Email</h4>
                    <p>ieeewieuom@gmail.com</p>
                  </div>
                </div>

                <div className="contact-item">
                  <FaMapMarkerAlt className="contact-icon" />
                  <div>
                    <h4>Address</h4>
                    <p>
                      University of Moratuwa
                      <br />
                      Katubedda, Moratuwa 10400
                      <br />
                      Sri Lanka
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="social-media-column animate-fade-in-right">
            <div className="social-media-card">
              <h3>Follow Us</h3>
              <p>Stay connected with our latest updates and events</p>
              <div className="social-links">
                <a
                  href="https://www.facebook.com/WIEUOM/"
                  className="social-link facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook />
                  <span>Facebook</span>
                </a>
                <a
                  href="https://www.linkedin.com/company/ieeewieuom/"
                  className="social-link linkedin"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin />
                  <span>LinkedIn</span>
                </a>
                <a
                  href="https://www.youtube.com/channel/UCOq_KTOv3pUNpAiQ4O-CUqw"
                  className="social-link youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube />
                  <span>YouTube</span>
                </a>
                <a
                  href="https://www.instagram.com/wie_uom/"
                  className="social-link instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                  <span>Instagram</span>
                </a>
                <a
                  href="https://www.tiktok.com/@ieee_wie_uom"
                  className="social-link tiktok"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok />
                  <span>TikTok</span>
                </a>
              </div>
            </div>
          </div>

          {/* <div className="contact-form-container animate-fade-in-right">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h3>Send us a message</h3>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Your full name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  placeholder="What is this regarding?"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="6"
                  placeholder="Tell us more about your inquiry..."
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="btn btn-primary submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  'Sending...'
                ) : (
                  <>
                    Send Message <FaPaperPlane />
                  </>
                )}
              </button>
            </form>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Contact;
